export default __webpack_public_path__ + "static/media/landing-page-desktop.0d1d09ca.png";